import React from 'react'
import classNames from 'classnames'

const STYLE = { width: 32, height: 32 }

export default function ShortcutLabel({
  children,
  className,
  colorScheme = 'default',
  ...otherProps
}) {
  const enhancedClassName = classNames(
    [
      className,
      'flexbox',
      'flexbox-align-center',
      'flexbox-justify-center',
      'margin-left-smaller',
      'line-height-one',
      'bold font-size-normal',
      'radius-small',
    ],
    {
      'background-shade-50 shade-20': colorScheme === 'default',
    }
  )
  return (
    <span className={enhancedClassName} style={STYLE} {...otherProps}>
      {children}
    </span>
  )
}
